
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store-accessor";
import Icon from "@/components/UI/Icon.vue";
import { SessionExpiredErrorNotification } from "@/types/notifications";
@Component({
  components: { Icon }
})
export default class SessionExpiredError extends Vue {
  @Prop()
  value!: SessionExpiredErrorNotification;

  get adminUrl(): string | undefined {
    return `${configStore.neededData?.adminUrl}?breakdanceRefreshSession=1`;
  }

  clear() {
    this.$emit("clear");
  }
}
